import {ApiVersionProperties} from '@/types/common/api/api.types';

export class BaseApi {

  public static ROOT_URL: string = process.env.NODE_ENV === 'production' ? 'https://api.community-coaching.com' : 'http://localhost:3030';
  public static IMAGE_URL: string = process.env.NODE_ENV === 'production' ? 'https://api.community-coaching.com' : 'http://localhost:3030';//window.location.origin : 'http://localhost:5173';

  public static login({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/auth`;
  }

  public static passwordForgot({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/auth/password-forgot`;
  }

  // Two-step password-forgot: the user clicked the confirmation link in the
  // first email and the FE posts the token here so the backend generates
  // the OTP and emails it.
  public static passwordForgotConfirm({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/auth/password-forgot-confirm`;
  }

  public static userData({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/user-data`;
  }

  public static customerInformation({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/auth/customer-information`;
  }

  public static coachingApproved({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/auth/coaching-approved`;
  }

  public static refresh({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/auth/refresh`;
  }

  public static logout({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/auth/logout`;
  }
}
